export const SuccessEnum = {
  Insert: 1,
  Update: 2,
  Delete: 3,
  Replication: 4,
};

export const NotifySendSalaryEnum = {
  Success: 1,
  Error: 2,
};

export const TypeNotifyEnum = {
  Default: 1,
  SendSalary: 2,
};
